export default function(x) {
  return x;
}



//////////////////
// WEBPACK FOOTER
// ./~/vue-d3/~/d3-axis/src/identity.js
// module id = bzkW
// module chunks = 0